import { TableRow, styled } from "@mui/material";

export const StyledRowTooltipParent = styled(TableRow)({
  "& .MuiTableCell-root": {
    padding: "0px",
  },
});
